import { compose, prop, sort, sortBy, toLower } from "ramda";
import { getTitle } from "util/mediaUtil";

export const sortMedia = modules => {
  return sort(
    (a, b) =>
      getTitle(a).toUpperCase().localeCompare(getTitle(b).toUpperCase()),
    modules,
  );
};

export const caseInsensitiveSort = p => sortBy(compose(toLower, prop(p)));
